import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { CardSummaryDetail } from "src/utils/type/card.type"
import { HomeService } from "../../services"
import {
  CsdRequestBody,
  HomeRequestBody,
} from "../../utils/type/statement-service.type"
import { AppSelectItems } from "../../components/app-select/app-select"
import { isErrorPayload } from "../types/ResponsePayload"

type HomeState = {
  csd: CardSummaryDetail[]
  cardDetails: AppSelectItems[]
  selectedStatementUuid: string
}

export const initialState: HomeState = Object.freeze({
  selectedStatementUuid: "",
  csd: [
    {
      id: "",
      imageUrl: "",
      name: "",
      maskedCardNumber: "",
      outstandingBalance: 0,
      paymentDueDate: "",
      isPrimaryCard: false,
      cardStatus: "",
      blockCode: "",
      cardStatusReported: "",
      cardStatusDisplay: "",
      statementDate: "",
      minimumPayableAmount: 0,
      cardType: "",
      primaryCustomerNumber: "",
    },
  ],
  cardDetails: [
    {
      value: "",
      label: "",
    },
  ],
})

const getCardSummaryByCustomer = createAsyncThunk(
  "home/getCardSummaryByCustomer",
  async (requestBody: CsdRequestBody) => {
    const { data } = await HomeService.getCardSummaryByCustomer(requestBody)
    return data
  }
)

const getCardsByStatementUuid = createAsyncThunk(
  "home/getCardsByStatementUuid",
  async (createBody: HomeRequestBody) => {
    const { data } = await HomeService.getCardsByStatementUuid(createBody)
    return data
  }
)

const homeSlice = createSlice({
  name: "home",
  initialState,
  reducers: {
    setSelectedStatementUuid(state, action: PayloadAction<string>) {
      state.selectedStatementUuid = action.payload
    },
    logout: (state) => {
      state.selectedStatementUuid = ""
      state.cardDetails = [{ value: "", label: "" }]
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCardSummaryByCustomer.fulfilled, (state, action) => {
      if (action.payload && action.payload.payload) {
        if (action.payload.payload.d !== undefined) {
          // Handle success case
          state.csd = action.payload.payload.d
        } else if (isErrorPayload(action.payload.payload)) {
          const errorPayload = action.payload.payload
          console.error(errorPayload)
        }
      }
    })
    builder.addCase(getCardsByStatementUuid.fulfilled, (state, action) => {
      if (
        action.payload.payload &&
        typeof action.payload.payload.items !== "undefined"
      ) {
        // Handle success case
        state.cardDetails = action.payload.payload.items.map<AppSelectItems>(
          (it: any) => {
            const cardNumber = it.cardNumber || "" // Default to an empty string if cardNumber is undefined

            return {
              value: it.statementUuid,
              label: `${it.cardName} - ${cardNumber.substring(
                cardNumber.length - 4
              )}`,
            }
          }
        )
      } else if (
        action.payload.payload &&
        isErrorPayload(action.payload.payload)
      ) {
        const errorPayload = action.payload.payload
        console.error(errorPayload)
      }
    })
  },
})

export const homeActions = {
  ...homeSlice.actions,
  getCardSummaryByCustomer,
  getCardsByStatementUuid,
}

export default homeSlice.reducer
